@import '~style-sheet-helpers/core.less';
@import '../../../../../constants/spacing.module.less';

.text-color {
  color: var(--default--text-color--17);
}

.description {
  margin-top: @space-24;
  margin-bottom: @space-24;
}

.balance-card {
  border: 1px solid var(--gray-E4E5E7);
  border-radius: @space-8;
  padding: @space-16;
  margin-bottom: @space-24;
  background-color: var(--gray-F9FAFB);
  height: auto;
}

.balance-card-content {
  gap: @space-16;
}

.balance-header {
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
}

.balance-title-row {
  align-items: center;
  gap: @space-4;
}

.balance-title {
  color: var(--gray-0F0F10);
}

.balance-amount {
  color: var(--gray-0F0F10);
}

.divider {
  height: 1px;
  background-color: var(--gray-E4E5E7);
  width: 100%;
}

.add-funds-section {
  gap: @space-8;
}

.checkbox-row {
  align-items: center;
  gap: @space-4;
}

.insurance-checkbox-row {
  align-items: flex-start;
  gap: @space-4;
  line-height: 1;
}

.enable-add-funds {
  line-height: 18px;
  font-size: 14px;
  margin-bottom: @space-8;
}

.include-insurance {
  font-size: 14px;
}

.button-container {
  width: auto;
}

.amount-to-add {
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
}

.add-funds-container {
  width: 100%;
}

.auto-fund-header {
  align-items: baseline;
  gap: @space-8;
  margin-bottom: @space-16;
}

.auto-fund-checkbox {
  font-size: 14px;
  line-height: 20px;
}

.auto-fund-info-icon {
  color: var(--gray-637381);
}

.view-settings-link {
  align-self: center;
}

.view-settings-content {
  gap: @space-4;
  align-items: center;

  svg {
    width: 12px;
    height: 12px;
  }
}

.auto-fund-inputs {
  gap: @space-12;
  width: 100%;
  align-items: flex-start;
}

.input-group {
  flex: 1 1 0;
  min-width: 0;
  gap: @space-8;
}

.input-label {
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: var(--gray-0F0F10);
}

.number-input-wrapper {
  gap: @space-4;
}

.number-input {
  width: 100%;
  height: 40px;
}

.times-per-day-text {
  font-size: 12px;
  line-height: 16px;
  color: var(--gray-637381);
}

.input-field {
  gap: @space-4;
  width: 100%;
}

.currency-input {
  width: 100%;
  height: 40px;
  border: 1px solid var(--gray-CFD1D3);
  background-color: var(--white);

  input {
    font-size: 14px;
    line-height: 20px;
    color: var(--gray-0F0F10);
  }
}

.number-input-full {
  width: 100%;
  height: 32px;
  border: 1px solid var(--gray-CFD1D3);
  background-color: var(--white);

  input {
    font-size: 14px;
    line-height: 20px;
    color: var(--gray-0F0F10);
  }
}

.insurance-section-container {
  border: 1px solid var(--gray-E4E5E7);
  border-radius: @space-8;
  padding: @space-16;
  margin-top: @space-24;
  background-color: var(--gray-F9FAFB);
}

.auto-insure-disclaimer {
  margin-left: @space-24;
  color: var(--gray-637381);
  font-size: 12px;
  line-height: 16px;
}

.funds-summary-container {
  border: 1px solid var(--gray-E4E5E7);
  border-radius: @space-8;
  padding: @space-16;
  margin-top: @space-24;
  background-color: var(--gray-F9FAFB);
}

.balance-icon {
  color: var(--gray-637381);
}

.add-fund-icon {
  color: var(--gray-637381);
  margin-left: @space-4;
}

.label-cost-card {
  border: 1px solid var(--gray-E4E5E7);
  border-radius: @space-8;
  padding: @space-16;
  gap: @space-4;
  margin-bottom: @space-16;
  background-color: var(--gray-F9FAFB);
}

.label-cost-content {
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: @space-8;
}

.carrier-info {
  align-items: center;
  gap: @space-4;
  flex: 1;
}

.carrier-icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.carrier-name {
  font-size: 14px;
  line-height: 24px;
  color: var(--gray-0F0F10);
}

.label-cost-amount {
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  color: var(--gray-0F0F10);
  flex-shrink: 0;
}
.auto-fund-balance {
  line-height: 18px;
  font-size: 12px;
  margin-bottom: @space-4;
  margin-top: @space-16;
}
.number-input-container {
  width: 120px;
}
.label {
  font-size: 14px;
  margin-left: @space-4;
  margin-top: @space-4;
}

.default-checkbox {
  margin-bottom: @space-16;
}
